import { IContainer, injectContainer } from './container';

export interface IMimeType {
    mimeTypeToFileExtension: (mimeType: string) => string | null;
    fileExtensionToMimeType: (fileExtension: string) => string | null;
}

const TYPES = {
    IMimeType: Symbol.for('IMimeType'),
};

export function injectMimeType(container: IContainer = injectContainer()): IMimeType {
    return container.get<IMimeType>(TYPES.IMimeType);
}

export function bindMimeType(val: IMimeType, container: IContainer = injectContainer()) {
    return container.bind<IMimeType>(TYPES.IMimeType, val);
}
